import { ApiTechnologies } from "@/api/technologies";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useTechnologiesData = () => {
  const { data: technologies, isLoading } = useLocalizedQuery({
    queryKey: ["technologies"],
    queryFn: lang => ApiTechnologies.getTechnologies(lang),
  });
  return { technologies, isLoading };
};
